import { Validator } from '../../../types'
import { findAndFixDuplicateIds, UniqueIdsSchema } from './duplicateIdsSearchEngine'
import { confirmOverwritingDuplicateIds } from './confirms'
import { createDuplicateIdsSearchAccumulators } from './createDuplicateIdsSearchAccumulators'

export const createDuplicateIdsValidator = <S extends object>(
  schema: UniqueIdsSchema,
  sectionNameDisplayedInConfirm: string
): Validator<S> => {
  return async (validatedEntity, isValidationDisabledForGroup) => {
    // Usually it would be an anti-pattern to give function a param that tells it not to do
    // what it does - but in this case, for a feature flag, this makes sense to me to disable
    // the feature centrally rather than at each implementation
    if (isValidationDisabledForGroup) {
      return { didValidateSuccessfully: true, correctedEntity: validatedEntity }
    }

    const idAccumulatorsMUTABLE = createDuplicateIdsSearchAccumulators()

    const correctedEntity = findAndFixDuplicateIds({
      searchedEntity: validatedEntity,
      idAccumulatorsMUTABLE,
      entityUniqueIdsSchema: schema
    })

    if (idAccumulatorsMUTABLE.duplicateIds.size === 0) {
      return { didValidateSuccessfully: true, correctedEntity: validatedEntity }
    }

    const overwriteConfirmed = await confirmOverwritingDuplicateIds(
      idAccumulatorsMUTABLE.duplicateIds,
      sectionNameDisplayedInConfirm
    )

    return overwriteConfirmed
      ? { didValidateSuccessfully: true, correctedEntity }
      : { didValidateSuccessfully: false, correctedEntity: null }
  }
}
